import React, { useEffect, useMemo } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SelectDropdown from '../components/SelectDropdown';
import { useGetBankListMutation } from '../lib/services/bankApi';
import { useDispatch, useSelector } from 'react-redux';
import { setBankList, setError, setRedirection, setSelectedBank } from '../lib/features/bankSlice';
import { generateChecksum } from '../lib/middleware/generateChecksum';
import PageHeader from '../components/PageHeader';
function RetriveBank() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedBank, error, bankList, redirectionLink } = useSelector((state) => state.bank);
    const [getBankList] = useGetBankListMutation();
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    useEffect(() => {
        const fetchBankList = async () => {
            try {
                const bodyData = {
                    mode: 'getBankList',
                    lamf: '',
                }
                const checksum = generateChecksum(bodyData)
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const response = await getBankList({ checksum, jwt_token, scrt }).unwrap()
                if (response && response.status === 'success') {
                    if (response.result) {
                        dispatch(setBankList([...response.result.otherBanks, ...response.result.popularBanks]))
                    }
                    if (response && response.redirect_url) {
                        dispatch(setRedirection(response.redirect_url))
                    }
                    //dispatch(setBankList([...response.result.otherBanks, ...response.result.popularBanks]))
                } else if (response.data && response.data.status === 'error') {
                    if (response.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                        
                    } else {
                        dispatch(setError(response.data.message))
                    }
                } else if (response.data && response.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                } else if (response.error) {
                    if (response.error && response.error.data && response.error.data.message) {
                        dispatch(setError(response.error.data.message))
                    } else {
                        dispatch(setError('Please check your internet or try again later.'))
                    }
                } else if (response && response.status === 'error') {
                    dispatch(setError(response.message))
                }
            } catch (error) {
                dispatch(setError('Something went wrong. Please try again later.'));
            }
        }
        fetchBankList()
    }, [getBankList, dispatch, navigate, jwt, secret])
    const handleSubmit = async () => {
        if (selectedBank) {
            //localStorage.setItem("lastVisitedPage", '/bank-details')
            //navigate('/bank-details');
            window.location.href = redirectionLink
        } else {
            dispatch(setError('Please select a bank.'));
        }
    }
    return (
        <div className='external-wrapper verify-bank retrive-statement'>
            <div className='page-content'>
                <PageHeader />
                <div className='page-heading'>
                    <h2 className='page-title'>Retrieve bank statements</h2>
                </div>
                <div className='verify-content'>
                    <h3>Select your salary/business bank account</h3>
                    <p>This may enable you to get a higher limit for the loan at a better interest rate.</p>
                    <SelectDropdown
                        name="retriveBank" id="bankControl"
                        options={bankList}
                        labelText='Select Bank'
                        value={selectedBank ? selectedBank.bankName : ''}
                        onChange={(option) => {
                            dispatch(setSelectedBank(option))
                            dispatch(setError(''))
                        }}
                    />
                    {error && <div className="error">{error}</div>}
                    <p className='dark-font'>To continue, you'll receive an OTP from our partner in the next step.</p>
                    {/* <p className='text-center'><Link to="/" style={{ textDecoration: 'underline' }}>Click here if your bank is not listed</Link></p> */}
                </div>
                <div className='bottom-footer ps-0 pe-0'>
                    <p className='powered-by'>Powered by <StarfinLogo /></p>
                    <button type="button" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                </div>
            </div>
        </div>
    );
}

export default RetriveBank;
